import store from '@/store'
import router from '@/router'
import paymentApi from '@/api/order/payment'
import { waitForTerminalOperation } from '@/services/terminal-operation-poller'

// Операции, которые оператор перестал ждать, закрыв диалог: operationId -> poller
const tracked = new Map()

function notify (text, color) {
  store.commit('app/setSnackbar', { value: true, text, color })
}

// Только страница этого заказа (?id= в адресе): в списке заказов currentEditOrder тоже выставлен,
// а карточки там обновляет сокет. Перечитываем статус и платёж, страницу не сбрасываем
function refreshIfOpen (orderId) {
  const id = String(orderId)
  if (String(router.currentRoute.query.id) === id && String(store.state.orders.currentEditOrder?.id) === id) {
    store.dispatch('orders/refreshCurrentOrderPayment', orderId).catch(() => {})
  }
}

/**
 * Досматривает операцию терминала после закрытия диалога: по финалу сообщает итог и обновляет карточку заказа.
 * expectedPaymentStatus — статус платежа при успехе: success для оплаты, refund для возврата.
 * unappliedText(operation) - функция: текст «деньги прошли, учёт ещё пишется» по ответу бэка
 * (applied: false после льготного окна поллера, cancelOrder - флаг операции). Жёлтое уведомление
 * без повторного опроса, бэк дописывает сам.
 */
export function trackInBackground ({ orderId, operationId, expectedPaymentStatus, successText, failText, unappliedText }) {
  if (!orderId || !operationId || tracked.has(operationId)) return

  const poller = waitForTerminalOperation(() => paymentApi.fetchTerminalOperation(orderId, operationId))
  tracked.set(operationId, poller)

  poller.promise
    .then(operation => {
      if (operation.status !== 'success') {
        notify(operation.error ? `${failText}: ${operation.error}` : failText, 'red')
      } else if (operation.applied === false) {
        notify(unappliedText ? unappliedText(operation) : `${successText}, но запись ещё идёт - проверьте заказ позже`, 'warning')
      } else if (operation.paymentStatus !== expectedPaymentStatus) {
        // терминал ответил, учёт итог не принял. У возврата это «терминал не подтвердил возврат» (эмулятор отвечает
        // отказом со Status 0) - «средства возвращены» здесь было бы ложью; у оплаты - поздний успех
        notify(operation.error && expectedPaymentStatus === 'refund'
          ? `${failText}: ${operation.error}`
          : `${successText}, но платёж не изменился — проверьте заказ`, 'warning')
      } else {
        notify(successText, 'green')
      }
      refreshIfOpen(orderId)
    })
    // сеть отказала трижды подряд: итог оператор увидит, открыв заказ
    .catch(() => {})
    .finally(() => tracked.delete(operationId))
}

/** Диалог открыли снова и он сам ждёт операцию: фоновый опрос не нужен */
export function untrack (operationId) {
  const poller = tracked.get(operationId)
  if (poller) poller.cancel()
  tracked.delete(operationId)
}
